import axios from "axios";
import { useEffect, useState } from "react";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from 'jodit-react';
import { ToastContainer, toast } from "react-toastify";
// import Select from 'react-select';
import { addCandidate, getAllCity, getCandidateByid, getCateg, getLocation, getLocations, getSkill, getSkillall, updateCandid } from "../../apifile/ApiFiles";
import { Accordion } from "react-bootstrap";
import AdvanceFileds from "../../search-candidate/AdvanceFileds";
import { Loaders } from "../../../pages/Loaders";
import { Select } from 'antd';
import dayjs from "dayjs";
const { Option } = Select;
function AddCandidateTable() {
  const [categorydata, setCategorydata] = useState();
  const [locationdata, setLocationdata] = useState();
  const [citydata, setCitydata] = useState();

  const [SkilData, setSkilData] = useState()
  console.log(SkilData);

  const [loader, setLoader] = useState(false)

  const params = useParams();
  const navigate = useNavigate();

  const [initialVal, setInitialVal] = useState({
    firstname: "",
    lastname: '',
    job_category: "",
    // city: '',
    location: "",
    skill: [],
    email: null,
    // email2: null,
    mobile: "",
    // mobile2: null,
    gender: '',
    // dob: '',
    salary: '',
    exprience: '2',
    candidate_desc: '',
    is_active: '',
    resume: '',



    // location: "",
    // to: "12/2/2024",
    // from: "12/2/2024",
    // is_active: null,


    // keywords: '',
    // exclusiveKeywords: '',
    // itSkills: '',
    // jobExperience: '',
    // experienceTo: '',
    // currentLocation: '',
    // salaryFrom: '',
    // salaryTo: '',
    // age: '',
    // lastname: '',
    // email: '',
    // date_of_Birth: '',
    // country: '',
    // state: '',
    // city: '',
    // nationality: '',
    // gender: '',
    // mobile: '',
    // careerLevel: '',
    // industry: '',
    // functionalArea: '',
    // jobExperience: '',
    // expectedSalary: '',
    // currentSalary: '',
    // salaryCurrency: '',
  });

  const changeHandler = (e) => {
    const clone = { ...initialVal };
    const value = e.target.value;
    const name = e.target.name;
    if (name == "mobile2") {
      if (value.length == 11) {
        return;
      }
    }
    if (name == "mobile") {
      if (value.length == 11) {
        return;
      }
    }

    clone[name] = value;
    setInitialVal(clone);
  };
  const [content, setContent] = useState('');
  const handleContentChange = (newContent) => {
    setContent(newContent);

  };
  const [genders, setGenders] = useState(null)
  const getById = async (id) => {
    const formatDateForInput = (isoDate) => {
      const date = new Date(isoDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    try {
      const res = await getCandidateByid(params?.id)
      console.log(res?.data);

      const formattedDob = res?.data?.dob ? formatDateForInput(res?.data?.dob) : '';
      setInitialVal({
        ...res?.data?.getacandidate,
        dob: formattedDob,
        candidate_desc: res?.data?.getacandidate?.candidate_desc || "",
        job_category: res?.data?.getacandidate?.job_category?._id || "",
        location: res?.data?.getacandidate?.location?._id || "",
        gender: res?.data?.getacandidate?.gender?._id || "",
        skill: res?.data?.getacandidate?.skill?.map((s) => s._id) || [],
      });
      setContent(res?.data?.getacandidate?.candidate_desc)

    } catch (error) {

      // alert('s')
    }
  };

  const getData = async () => {
    try {
      const rescategory = await getCateg()
      // console.log(rescategory);
      const maped = rescategory?.data?.map((item) => {
        return { ...item, value: item.category_name, label: item.category_name }
      })



      setCategorydata(maped);

    } catch (error) {
      // alert("wrog");
    }
  };
  const getData1 = async () => {
    try {

      const reslocation = await getLocations()
      setLocationdata(reslocation);
      // const res = await getAllCity()
      // setCitydata(res?.data);
    } catch (error) {
      // alert("wrog");
    }
  };

  const getGender = async (id) => {
    try {
      const gender = await axios.get(
        `https://abarishr.hennainternational.in/api/gender/public`
      );
      setGenders(gender?.data);
      const skill = await getSkillall()
      setSkilData(skill?.data)
    } catch (error) {

    }
  };

  useEffect(() => {
    getData();
    getGender()
    getData1();

  }, []);

  const notify = (updateMassage) => toast(updateMassage);

  const handleSubmit = async () => {
    // setLoader(true)
    // console.log(initialVal);
    // return
    if (params?.id) {
      try {
        // const res = await axios.put(
        //   `https://abarishr.hennainternational.in/api/candidate/update/${params?.id}`,
        //   initialVal
        // );
        const res = await updateCandid(params?.id, { ...initialVal, jobSkills: [initialVal?.itSkills], candidate_desc: content, location: initialVal?.location })
        if (res?.data?._id) {
          notify("updated Successfull");
        } else {
          alert(res.message)
          // setLoader(false)
          return
        }

        setTimeout(() => {
          navigate("/admin/candidate-list");
        }, 1000);
      } catch (error) {
        alert(error?.response?.data?.message)
      }
    } else {
      try {
        const res = await addCandidate({ ...initialVal, jobSkills: [initialVal?.itSkills], candidate_desc: content, location: initialVal?.location })
        console.log(res);

        if (res.data?._id) {
          notify("Add Successfull");
        } else {
          alert(res.message)
          // setLoader(false)
          return
        }
        setTimeout(() => {
          navigate("/admin/candidate-list");
        }, 1000);
      } catch (error) {
        // console.log();
        alert(error?.response?.data?.message)
      }
      setLoader(false)
    }
  };

  const [showCateg, setShoCagte] = useState([])
  const onchangeHandleCateg = (e) => {
    const clone = { ...initialVal, job_category: e._id }
    setShoCagte([{ ...e }])
    setInitialVal(clone)
  }
  const changeHandler2 = async (e) => {
    const file = e.target.files[0];
    const allowedExtensions = /(\.pdf|\.xls|\.txt|\.doc|\.docx)$/i;

    if (!file) {
      return
    }

    if (!allowedExtensions.exec(file.name)) {
      alert('Only .PDF, .XLS, .TXT, .DOC, .DOCX files are allowed.');
      setInitialVal({
        ...initialVal,
        resume: null,
      });
      return;
    }
    const data = new FormData();
    console.log(data);
    // setInitialVal({
    //   ...initialVal,
    //   resume: data
    // });


    data.append('image', file);

    try {
      const res = await axios.post('https://abarishr.hennainternational.in/api/cloudinary/addImage', data);
      setInitialVal({
        ...initialVal,
        resume: res.data?.url
      });
    } catch (error) {
      const pdfUrl = error.response.data.stack
      // console.log(pdfUrl);
      const match = pdfUrl.match(/file-\d+\.pdf/);
      if (match) {
        setInitialVal({
          ...initialVal,
          resume: match[0],
        });
        console.log(match[0]); // Outputs: file-1732781921917.pdf
      }
    }
  }

  useEffect(() => {
    getById()
  }, [params?._id])

  useEffect(() => {
    if (locationdata?.data?.length > 0 && !initialVal?.location) {
      setInitialVal((prev) => ({
        ...prev,
        location: locationdata.data[0]._id,
      }));
    }
  }, [locationdata]);

  useEffect(() => {
    if (genders?.length > 0 && !initialVal?.gender) {
      setInitialVal((prev) => ({
        ...prev,
        gender: genders[0]._id,
      }));
    }
  }, [genders])

  return (
    <>
      <div className="pageTable">
        {/* {loader && <Loaders />} */}
        <ToastContainer />
        <form>
          <div className="row mb-3">
            <div className="form-group   col-lg-4">
              <label htmlFor="language_level">
                <strong>First Name <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <input
                className="form-control"
                placeholder="First Name"
                type="text"
                name="firstname"
                value={initialVal.firstname}
                onChange={changeHandler}
              />
            </div>
            <div className="form-group   col-lg-4">
              <label htmlFor="language_level">
                <strong>Last Name <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <input
                className="form-control"
                placeholder="Last Name"
                type="text"
                name="lastname"
                value={initialVal.lastname}
                onChange={changeHandler}
              />
            </div>

            <div className="form-group   col-lg-4">
              <label htmlFor="lang" className="mb-1">
                <strong>Job Category <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <Select
                showSearch
                allowClear
                placeholder="Select Job Category"
                value={initialVal?.job_category}
                onChange={(value) =>
                  changeHandler({ target: { name: 'job_category', value } })
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {categorydata &&
                  categorydata.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.category_name}
                    </Option>
                  ))}
              </Select>
              {/* <Select
                // isMulti
                defaultValue={showCateg}
                value={showCateg}
                name="job_category"
                options={categorydata}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={onchangeHandleCateg}
              /> */}
            </div>

            <div className="form-group   col-lg-4">
              <label htmlFor="language_level" className="mb-1">
                <strong>Email<span style={{ color: 'red' }}>*</span></strong>
              </label>
              <input
                className="form-control"
                placeholder="Email"
                type="Email"
                name="email"
                value={initialVal.email}
                onChange={changeHandler}
              />
            </div>

            {/* <div className="form-group   col-lg-4">
              <label htmlFor="language_level" className="mb-1">
                <strong>Alt Email <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <input
                className="form-control"
                placeholder="Email 2"
                type="Email"
                disabled={params?.id}
                name="email2"
                value={initialVal.email2}
                onChange={changeHandler}
              />
            </div> */}

            <div className="form-group   col-lg-4">
              <label htmlFor="language_level">
                <strong>Mobile <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <input
                className="form-control"
                placeholder="+91 "
                type="number"
                name="mobile"
                value={initialVal.mobile}
                onChange={changeHandler}
              />

              {initialVal.mobile?.length < 10 && (
                <p style={{ color: "red" }}>Number must be 10 digit</p>
              )}
            </div>

            {/* <div className="form-group   col-lg-4">
              <label htmlFor="language_level">
                <strong>Alt Mobile <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <input
                className="form-control"
                placeholder="+91"
                type="number"
                name="mobile2"
                disabled={params?.id}
                value={initialVal.mobile2}
                onChange={changeHandler}
              />
              {initialVal.mobile2?.length < 10 && (
                <p style={{ color: "red" }}>Number must be 10 degit</p>
              )}
            </div> */}


            {/* <div className="form-group   col-lg-6">
              <label htmlFor="language_level">
                <strong>Password </strong>
              </label>
              <input
                className="form-control"
                disabled={params?.id ? true : false}
                placeholder="password"
                type="password"
                name="password"
                value={initialVal.password}
                onChange={changeHandler}
              />
            </div> */}



            {/* <div className="form-group   col-lg-4">
              <label htmlFor="lang" className="mb-1">
                <strong>Location <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <select
                className="form-select"
                onChange={changeHandler}
                name="location"
                value={initialVal?.location}
              >
                <option>Select Location</option>
                {locationdata &&
                  locationdata?.data?.map((item) => {
                    return (
                      <option value={item._id}>{item.location_name}</option>
                    );
                  })}
              </select>
            </div> */}
            <div className="form-group   col-lg-4">
              <label htmlFor="lang" className="mb-1">
                <strong>Location / City <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <select
                className="form-select"
                onChange={changeHandler}
                name="location"
                value={initialVal?.location}
              >
                <option>Select Location / City</option>
                {locationdata &&
                  locationdata?.data?.map((item) => {
                    return (
                      <option value={item._id}>{item.location_name}</option>
                    );
                  })}
              </select>
              {/* <input
                className="form-control"
                placeholder="Current Location"
                type="text"
                name="current_location"
                value={initialVal.current_location}
                onChange={changeHandler}
              /> */}
            </div>

            <div className="form-group   col-lg-4">
              <label htmlFor="lang" className="mb-1">
                <strong>Gender <span style={{ color: 'red' }}>*</span></strong>
              </label>
              <select className="form-select" id="lang" value={initialVal?.gender} name="gender" onChange={changeHandler}>
                <option value>Select Gender</option>
                {genders &&
                  genders?.map((item) => {
                    return <option key={item._id} value={item._id}>{item.gender}</option>;
                  })}
              </select>
            </div>

            <div className="form-group   col-lg-4">
              <label htmlFor="lang" className="mb-1">
                <strong>Upload CV </strong>
              </label>
              <input className="form-control" type="file" onChange={changeHandler2} name="resume" />
            </div>
            {/* <div className="form-group col-md-4">
              <label>Date of Birth <span style={{ color: 'red' }}>*</span></label>
              <input
                type="date"
                name="dob"
                value={initialVal.dob}
                onChange={changeHandler}
                className="form-control"
              />
            </div> */}
            <div className="form-group col-md-4">
              <label>Experience <span style={{ color: 'red' }}>*</span></label>
              <input
                type="number"
                name="exprience"
                value={initialVal.exprience}
                onChange={changeHandler}
                className="form-control"
              />
            </div>

            <div className="form-group col-md-4">
              <label>Salary </label>
              <input
                type="number"
                name="salary"
                value={initialVal.salary}
                onChange={changeHandler}
                className="form-control"
                placeholder="Salary"
              />
            </div>
            <div className="form-group col-md-4">
              <label>
                Skills
              </label>
              <Select
                mode="multiple"
                showSearch
                allowClear
                placeholder="Select Skill"
                value={initialVal?.skill}
                onChange={(value) => changeHandler({ target: { name: 'skill', value } })}
                style={{ width: '100%' }}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {SkilData &&
                  SkilData?.data?.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.job_skills}
                    </Option>
                  ))}
              </Select>
            </div>
            {/* <div className="form-group col-md-4">
              <label>Status <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" id="lang" value={initialVal?.is_active} name="is_active"
                // onChange={(e) => {
                //   const value = e.target.value === "true";
                //   changeHandler({
                //     target: {
                //       name: e.target.name,
                //       value: value,
                //     },
                //   });
                // }}
                onChange={changeHandler}
              >
                <option selected>Select Status</option>
                <option value={'1'}>Active</option>
                <option value={'0'}>InActive</option>
              </select>

            </div> */}



            {/* <div className="form-group col-md-4">
              <label>Start Date</label>
              <input
                type="date"
                name="keywords"
                value={initialVal.keywords}
                onChange={changeHandler2}
                className="form-control"
              />
            </div>
            <div className="form-group col-md-4">
              <label>End Date</label>
              <input
                type="date"
                name="keywords"
                value={initialVal.keywords}
                onChange={changeHandler2}
                className="form-control"
              />
            </div> */}




            {/* <div className="form-group col-12">
              <label htmlFor="lang" className="mb-1">
                <strong>Open Advance Feild To Fill Extra Fileds</strong>
              </label>

            </div> */}
            {/* Advance fileds */}
            {/* <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Advance Feild</Accordion.Header>
                <Accordion.Body>
                  <AdvanceFileds changeHandler2={changeHandler} initialVal={initialVal} getById={getById} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion> */}



            <div className="form-group mb-3 ">
              <label htmlFor="language_level">
                <strong>Candidate description</strong> <span style={{ color: 'red' }}>*</span>
              </label>
              <JoditEditor
                value={content}
                onChange={handleContentChange}
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="is_default">
                <strong>Is Active?</strong>
              </label>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="is_active"
                  value={1}
                  onChange={changeHandler}
                  checked={Number(initialVal?.is_active) === 1}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Yes
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="is_active"
                  value={0}
                  onChange={changeHandler}
                  checked={Number(initialVal?.is_active) === 0}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  No
                </label>
              </div>
            </div>

            {/* <div className="form-group mb-3 ">
              <label htmlFor="is_default">
                <strong>Is Active?</strong>
              </label>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="is_active"
                  value={1}
                  onChange={changeHandler}
                  // checked={initialVal?.is_active == 1}
                  defaultChecked
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Yes
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="is_active"
                  value={0}
                  // checked={initialVal?.is_active == 0}
                  onChange={changeHandler}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  No
                </label>
              </div>
            </div> */}
          </div>
        </form>
      </div>

      <div className="text-center mt-2">
        <button
          className="btn btn-large btn-primary"
          type="button"
          onClick={handleSubmit}
        >
          Save <BsFillArrowRightCircleFill />
        </button>
      </div>


    </>
  );
}
export default AddCandidateTable;
